import { useEffect, useState } from 'react';
import { PLAYER_PLACEHOLDER, playerImageCandidates } from '../utils/playerAssets';

interface PlayerPhotoProps {
  name?: string;
  position?: string;
  team?: string;
  espnId?: string | number;
  sleeperId?: string | number;
  imageUrl?: string;
  className?: string;
  alt?: string;
}

export function PlayerPhoto({
  name,
  position,
  team,
  espnId,
  sleeperId,
  imageUrl,
  className,
  alt,
}: PlayerPhotoProps) {
  const candidates = [
    ...(imageUrl ? [imageUrl] : []),
    ...playerImageCandidates(name, position, team, espnId, sleeperId || imageUrlSleeperId(imageUrl)),
  ].filter((url, index, list) => url && list.indexOf(url) === index);

  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [name, sleeperId, espnId, imageUrl]);

  const src = candidates[index] || PLAYER_PLACEHOLDER;

  return (
    <img
      src={src}
      alt={alt || name || ''}
      className={className}
      onError={() => {
        setIndex((current) => (current + 1 < candidates.length ? current + 1 : current));
      }}
    />
  );
}

function imageUrlSleeperId(imageUrl?: string): string | undefined {
  if (!imageUrl) return undefined;
  const match = imageUrl.match(/sleepercdn\.com\/content\/nfl\/players\/(?:thumb\/)?(\w+)\.jpg/);
  return match?.[1];
}
